import { apiClient, getAuthHeader } from "./apiConfig";

// -------- Location --------
export const fetchCountries = async () => {
  const res = await apiClient.get(`/location/countries`, getAuthHeader());
  return res.data?.data || [];
};

export const fetchStates = async (countryId) => {
  const res = await apiClient.get(`/location/states/${countryId}`, getAuthHeader());
  return res.data?.data || [];
};

export const fetchCities = async (stateId) => {
  const res = await apiClient.get(`/location/cities/${stateId}`, getAuthHeader());
  return res.data?.data || [];
};

// -------- Firms --------
export const fetchFirms = async () => {
  const res = await apiClient.get(`/firms/get_all`, getAuthHeader());
  const all = res.data?.data || [];
  return all.filter((u) => u.role === "firm");
};

export const deleteFirmById = async (id) => {
  return await apiClient.delete(`/firms/delete/${id}`, getAuthHeader());
};

export const createFirm = async (formData) => {
  return await apiClient.post(`/firms/create`, formData, {
    ...getAuthHeader(),
    headers: { ...getAuthHeader().headers, "Content-Type": "multipart/form-data" },
  });
};

export const updateFirm = async (userId, formData) => {
  return await apiClient.post(`/firms/update/${userId}`, formData, {
    ...getAuthHeader(),
    headers: { ...getAuthHeader().headers, "Content-Type": "multipart/form-data" },
  });
};
